import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { DateFormatters } from 'src/app/utils/formatters';
import { hasValidator } from '../_helpers/functions';
defineLocale('pt-br', ptBrLocale);

const TAG = 'DatepickerComponent';

@Component({
    selector: 'sume-datepicker',
    templateUrl: './datepicker.component.html',
})
export class DatepickerComponent implements OnInit {
    @Input() label: string;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;
    @Input() messages: any;
    @Input() changeText = false;
    @Input() helpMessage: string;

    value: unknown;

    isRequired = false;

    constructor(private bsLocaleService: BsLocaleService) {
        this.bsLocaleService.use('pt-br');
    }

    ngOnInit(): void {
        this.isRequired = hasValidator(
            this.formGroup.controls[this.controlName],
            'required'
        );

        try {
            const dataSelecionada = DateFormatters.formatDate(
                this.formControl.value
            );
            this.value = dataSelecionada;
        } catch (error) {
            this.value = '';
        }

        this.formControl.valueChanges.subscribe(value => {
            // console.info(TAG, `${this.controlName}: data selecionada ${value}`);
            try {
                this.value = DateFormatters.sumeDateFormatter(value);
                // console.debug(
                //     TAG,
                //     `${this.controlName}: valor alterado para ${value}`
                // );
            } catch (error) {
                this.value = '';
                // console.log(error);
            }
        });
    }
    onDateChange(dateValue: string) {
        if (dateValue == null || String(dateValue).trim() === '') {
            // console.debug(
            //     TAG,
            //     `${this.controlName}: data selecionada ${dateValue}`
            // );
            this.formControl.reset();
        } else {
            // console.debug(
            //     TAG,
            //     `${this.controlName}: data selecionada ${dateValue}`
            // );
            const [dd, mm, yyyy] = new Date(dateValue)
                .toLocaleDateString('pt-BR')
                .split('/');
            // console.debug(
            //     `DatepickerComponent: data convertida ${yyyy}-${mm}-${dd}`
            // );
            this.formControl.setValue(`${yyyy}-${mm}-${dd}`, {
                emitEvent: true,
            });
        }
    }

    get formControl(): AbstractControl {
        return this.formGroup.get(this.controlName);
    }
}
